import { render, staticRenderFns } from "./prePrescribeDetailModal.vue?vue&type=template&id=0bc27275"
import script from "./prePrescribeDetailModal.vue?vue&type=script&lang=js"
export * from "./prePrescribeDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports